import { Text, Secondary, Stack, Content } from '@kinesis/bungle';
import { noop } from 'lodash/fp';
import { ConnectedApplicationItem } from './connected-application-item';
import { Layout } from '@/components/layout';
import type { ConnectedApplication } from '@/api/oauth';

type Props = {
  applications?: ConnectedApplication[];
  now: string;
  onRevoke?: (clientId: string) => void;
};

const ConnectedApplications = ({
  applications = [],
  now,
  onRevoke = noop,
}: Props) => (
  <Layout variant='narrow'>
    <Content>
      <Stack space='medium'>
        <Text>
          Connected applications are AI tools and services you have authorised
          to access Kinesis on your behalf. Revoking an application immediately
          stops it from accessing your account.
        </Text>
        {applications.length === 0 ? (
          <Text>
            <Secondary>
              You haven&rsquo;t connected any applications yet. When you
              authorise an AI tool to access Kinesis, it will appear here.
            </Secondary>
          </Text>
        ) : (
          <Stack space='small'>
            {applications.map((application) => (
              <ConnectedApplicationItem
                key={application.client.client_id}
                application={application}
                now={now}
                onRevoke={onRevoke}
              />
            ))}
          </Stack>
        )}
      </Stack>
    </Content>
  </Layout>
);

export { ConnectedApplications };
